import React from 'react';

export function MoreIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M9.16602 9.99984C9.16602 10.2209 9.25381 10.4328 9.41009 10.5891C9.56637 10.7454 9.77834 10.8332 9.99935 10.8332C10.2204 10.8332 10.4323 10.7454 10.5886 10.5891C10.7449 10.4328 10.8327 10.2209 10.8327 9.99984C10.8327 9.77882 10.7449 9.56686 10.5886 9.41058C10.4323 9.2543 10.2204 9.1665 9.99935 9.1665C9.77834 9.1665 9.56637 9.2543 9.41009 9.41058C9.25381 9.56686 9.16602 9.77882 9.16602 9.99984Z"
        fill="#FEFEFE"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16602 15.8333C9.16602 16.0543 9.25381 16.2663 9.41009 16.4226C9.56637 16.5789 9.77834 16.6667 9.99935 16.6667C10.2204 16.6667 10.4323 16.5789 10.5886 16.4226C10.7449 16.2663 10.8327 16.0543 10.8327 15.8333C10.8327 15.6123 10.7449 15.4004 10.5886 15.2441C10.4323 15.0878 10.2204 15 9.99935 15C9.77834 15 9.56637 15.0878 9.41009 15.2441C9.25381 15.4004 9.16602 15.6123 9.16602 15.8333Z"
        fill="#FEFEFE"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16602 4.16683C9.16602 4.38784 9.25381 4.5998 9.41009 4.75608C9.56637 4.91237 9.77834 5.00016 9.99935 5.00016C10.2204 5.00016 10.4323 4.91237 10.5886 4.75608C10.7449 4.5998 10.8327 4.38784 10.8327 4.16683C10.8327 3.94582 10.7449 3.73385 10.5886 3.57757C10.4323 3.42129 10.2204 3.3335 9.99935 3.3335C9.77834 3.3335 9.56637 3.42129 9.41009 3.57757C9.25381 3.73385 9.16602 3.94582 9.16602 4.16683Z"
        fill="#FEFEFE"
        stroke="#FEFEFE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
